import React from "react";
import Page from "components/Page";
import { Props } from "./Roles";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Roles = lazyWithRetry(() => import("./Roles"));

export default (props: Props) => (
  <Page>
    <Roles {...props} />
  </Page>
);
